import { call, select } from "redux-saga/effects";
import { TempIdsMap } from "../../../../api/api-slice";
import { selectComponentTempIdsMap } from "../../../../api/selectors";
import ComponentsService from "../../../../../services/ComponentsService";
import { IUpdateComponentCommand } from "@growth-machine-llc/stridist-api-client";
import { selectComponentById } from "../../../selectors/curriculum";
import { duplicateWorkoutExercise } from "./operation";

export default function* duplicateExerciseWorker(payload: {
  componentId: number;
  workoutSectionId: number;
  exerciseId: number;
  newExerciseId: number;
}) {
  const { componentId, workoutSectionId, exerciseId, newExerciseId } = payload;
  if (!componentId || !workoutSectionId || !exerciseId) return;
  const component = yield select(selectComponentById(componentId));
  if (!component) return;

  const updatedContent = duplicateWorkoutExercise(
    workoutSectionId,
    exerciseId,
    newExerciseId,
    component.content,
  );
  const map: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedComponentId = map?.[componentId] || componentId;

  const command: IUpdateComponentCommand = {
    id: checkedComponentId,
    content: updatedContent,
  };

  try {
    yield call(ComponentsService.update, command);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
